import {
  AudioWaveform,
  Building,
  ChartPie,
  ClipboardList,
  Command,
  GalleryVerticalEnd,
  NotebookText,
  SquareKanban,
  StickyNote,
  TicketSlash,
  UserRoundCog,
  Workflow,
} from 'lucide-vue-next'

export const data = {
  user: {
    name: 'Alex Gefter',
    email: 'm@example.com',
    avatar: '/avatars/shadcn.jpg',
  },
  teams: [
    {
      name: 'Acme Inc',
      logo: GalleryVerticalEnd,
      plan: 'Enterprise',
    },
    {
      name: 'Acme Corp.',
      logo: AudioWaveform,
      plan: 'Startup',
    },
    {
      name: 'Evil Corp.',
      logo: Command,
      plan: 'Free',
    },
  ],
  navMain: [
    {
      title: 'Tickets',
      url: '#',
      icon: StickyNote,
      isActive: true,
      items: [
        {
          title: 'All Tickets',
          url: '/tickets',
          label: 123,
        },
      ],
    },
    {
      title: 'Customers',
      url: '/customers',
      icon: Building,
      future: true,
      items: null,
    },
    {
      title: 'Projects',
      url: '/projects',
      icon: SquareKanban,
      future: true,
      items: null,
    },
    // {
    //   title: 'Contacts',
    //   url: '#',
    //   icon: ContactRound,
    //   future: true,
    //   items: null,
    // },
    {
      title: 'Insights',
      url: '',
      icon: ChartPie,
      isActive: false,
      items: [
        {
          title: 'Client Insights',
          url: '/insights/clients',
        },
        {
          title: 'Ticket Insights',
          url: '/insights/tickets',
        },
      ],
    },
    {
      title: 'Settings',
      type: 'section-title',
    },
    {
      title: 'Ticket Config',
      url: '/settings/ticket/types',
      icon: TicketSlash,
      isActive: false,
      items: [
        {
          title: 'Ticket Types',
          url: '/settings/ticket/types',
        },
        {
          title: 'Statuses',
          url: '/settings/ticket/statuses',
        },
        {
          title: 'Priorities',
          url: '/settings/ticket/priorities',
        },
        {
          title: 'Categories',
          url: '/settings/ticket/categories',
        },
      ],
    },
    {
      title: 'Teams Config',
      url: '/settings/team/users',
      icon: UserRoundCog,
      isActive: false,
      items: [
        {
          title: 'Users',
          url: '/settings/team/users',
        },
        {
          title: 'Teams',
          url: '/settings/team/teams',
        },
      ],
    },
    {
      title: 'Queues',
      url: '/settings/queue',
      icon: ClipboardList,
      isActive: false,
      items: [],
    },
    {
      title: 'SLA',
      url: '/settings/sla/slas',
      icon: NotebookText,
      isActive: false,
      items: [
        {
          title: 'SLAs',
          url: '/settings/sla/slas',
        },
        {
          title: 'Calendars',
          url: '/settings/sla/calendars',
        },
      ],
    },
    {
      title: 'Workflow',
      url: '/settings/workflow',
      icon: Workflow,
      isActive: false,
      items: null,
    },
  ],
}
